import angular from 'angular';

import { routesConfig } from './dashboard.routes';

export default angular.module('dashboard', []).config(routesConfig);
